<template>
  <div class="main-content-container container-fluid px-2 px-sm-4 bgcontainer">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-3 py-sm-4">
      <div class="col-12 text-center text-sm-left mb-0 ">
        <span>Bienvenid@, {{ user.nombre + ' ' + (user.apellido1 != null ? user.apellido1.trim() : '') }}</span>
        <h3 class="page-title">Selección de contrato:</h3>
      </div>
    </div>
    <div class="container px-0">
      <div class="row">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <select class="form-control bold mb-3" @change="selContrato" v-model="contro_id">
            <option value="0" disabled>Selecciona un contrato</option>
            <option v-for="row in listContratos" :value="row.contro_id" :key="row.contro_id">
              {{ row.contra_id + ' - ' + row.contro_id + ' - ' + row.direccion1 }}
            </option>
          </select>
        </div>
      </div>
      <div class="row mt-2 mt-sm-3">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <form>
            <div class="form-group row mb-2">
              <label for="horario" class="col-12 col-sm-4 col-form-label">Horario</label>
              <div class="col-12 col-sm-8">
                <input type="text" readonly class="form-control" id="horario" v-model="horario" />
              </div>
            </div>

            <div class="form-group row mb-2">
              <label for="dias" class="col-12 col-sm-4 col-form-label">Días</label>
              <div class="col-12 col-sm-8">
                <input type="text" readonly class="form-control" id="dias" v-model="dias" />
              </div>
            </div>

            <div class="form-group row mb-3">
              <label for="categoria" class="col-12 col-sm-4 col-form-label">Categoría:</label>
              <div class="col-12 col-sm-8">
                <input type="text" readonly class="form-control" id="categoria" v-model="categoria" />
              </div>
            </div>

            <div class="text-center">
              <!-- ✅ Mensaje de error de ubicación -->
              <div v-if="error" class="alert alert-danger mb-3" style="font-size: 0.85rem; padding: 0.5rem;">
                {{ error }}
              </div>
              <!-- ✅ Botón "Verificar mi ubicación" con loader -->
              <button
                type="button"
                v-if=" dataContro != null  && (!flexible_coordenadas && !ubicacionVerificada)"
                @click="requestPermissionManually"
                :disabled="verificandoUbicacion"
                class="btn-accent mb-3 w-100 w-sm-auto"
              >
                {{ verificandoUbicacion ? 'Verificando...' : 'Verificar mi ubicación' }}
              </button>

              <!-- ✅ Botón "CONTINUAR" -->
              <d-button
                type="button"
                @click="irAContratas"
                :disabled="!puedeContinuar"
                class="btn-accent mb-3 w-100 w-sm-auto"
              >
                CONTINUAR
              </d-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../config/api";

export default {
  name: "Home",
  data() {
    return {
      listContratos: [],
      user: {},
      contro_id: 0,
      horario: null,
      dias: null,
      categoria: null,
      usuario_id: 0,
      error: null, // ✅ se mostrará en UI
      position: null,
      flexible_coordenadas: false,
      ubicacionVerificada: false,
      verificandoUbicacion: false,
      dataContro: null
    };
  },
  computed: {
    puedeContinuar() {
      if (this.contro_id == 0) return false;
      if (this.flexible_coordenadas) return true;
      return this.ubicacionVerificada;
    }
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem("user")) || {};
    this.usuario_id = this.user.numero;
    this.$isLoading(true);
    this.listContratos = await this.getData();
    this.$isLoading(false);
  },
  methods: {
    resetEstadoContrato() {
      this.horario = null;
      this.dias = null;
      this.categoria = null;
      this.flexible_coordenadas = false;
      this.ubicacionVerificada = false;
      this.verificandoUbicacion = false;
      this.error = null; // ✅ limpiar mensaje al cambiar contrato
      this.dataContro = null;
    },

    checkGeolocationSupport() {
      if (!navigator.geolocation) {
        this.error = "Tu navegador no soporta geolocalización.";
        this.ubicacionVerificada = false;
        return;
      }

      if (navigator.permissions && navigator.permissions.query) {
        this.checkPermissionState();
      } else {
        this.getLocation();
      }
    },

    async checkPermissionState() {
      try {
        const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
        if (permissionStatus.state === "granted") {
          this.getLocation();
        } else if (permissionStatus.state === "denied") {
          this.ubicacionVerificada = false;
          this.error = "Has denegado el acceso a tu ubicación. Por favor, permite el acceso desde la configuración de tu navegador.";
        } else {
          this.getLocation();
        }
      } catch (error) {
        this.getLocation();
      }
    },

    getLocation() {
      this.verificandoUbicacion = true;
      this.error = null; // ✅ limpiar error al iniciar nueva verificación

      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      };

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.position = position;
          this.ubicacionVerificada = true;
          this.verificandoUbicacion = false;
          this.error = null;
          this.$emit("location-updated", position.coords);
        },
        (error) => {
          this.ubicacionVerificada = false;
          this.verificandoUbicacion = false;
          let errorMsg = "No se pudo obtener tu ubicación.";
          if (error.code === error.PERMISSION_DENIED) {
            errorMsg = "Permiso de ubicación denegado. Por favor, permite el acceso a tu ubicación.";
          } else if (error.code === error.POSITION_UNAVAILABLE) {
            errorMsg = "La ubicación no está disponible en este momento.";
          } else if (error.code === error.TIMEOUT) {
            errorMsg = "Tiempo de espera agotado. Intenta nuevamente.";
          }
          this.error = errorMsg; // ✅ mensaje visible en UI
        },
        options
      );
    },

    requestPermissionManually() {
      this.getLocation();
    },

    selContrato() {
      this.resetEstadoContrato();

      if (this.contro_id == 0) return;

      const contrato = this.listContratos.find(x => x.contro_id == this.contro_id);
      if (!contrato) return;

      this.dataContro = contrato;
      localStorage.setItem("controdata", JSON.stringify(contrato));

      this.horario = contrato.horario;
      this.dias = contrato.diascontro;
      this.categoria = contrato.categoria;
      this.flexible_coordenadas = contrato.flexible_coordenadas;

      if (!this.flexible_coordenadas) {
        this.checkGeolocationSupport();
      }
    },

    irAContratas() {
      if (this.contro_id == 0) {
        alert("Debes seleccionar contrato!");
        return;
      }

      const flexible = this.dataContro && this.dataContro.flexible_total === 1;

      if (!flexible) {
        if (!this.horario || this.horario.length === 0) {
          alert("No puedes fichar, contrato sin horario o no flexible!");
          return;
        }
        if (!this.dias || this.dias.length === 0) {
          alert("No puedes fichar, contrato sin días o no flexible!");
          return;
        }
      }

      this.$router.push("fichaje");
    },

    async getData() {
      try {
        const response = await api.request("get", "/obtenerContratos/" + this.usuario_id);
        return response.data || [];
      } catch (error) {
        console.error("Error al cargar contratos:", error);
        return [];
      }
    }
  }
};
</script>

<style scoped>
/* Estilos para móviles */
@media (max-width: 767.98px) {
  .main-content-container {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  .page-header {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .page-title {
    font-size: 1.25rem;
  }

  .form-control {
    font-size: 0.9rem;
    padding: 0.375rem 0.5rem;
  }

  .col-form-label {
    padding-bottom: 0.25rem;
  }

  .form-group {
    margin-bottom: 0.75rem;
  }
}

/* Estilos generales */
.bgcontainer {
  min-height: 100vh;
}

.btn-accent {
  min-width: 150px;
  padding: 0.5rem 1.5rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-accent:hover:not(:disabled) {
  background-color: #0056b3;
}

.btn-accent:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #6c757d;
}

/* Estilo para mensaje de error */
.alert {
  margin-bottom: 1rem;
  border-radius: 4px;
}
</style>